import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createSelector, createStructuredSelector } from 'reselect';
import { superChatSelector } from 'ai/selectors/superChatSelector';
import { coreUserDataSelector } from 'viewModel/selectors/user/coreUserDataSelector';
import SuperChatActions from 'ai/actions/superChatActions';
import FrameworkUtils from 'utils/framework';
import LanguageLocaleUtils from 'utils/LanguageLocale';
import sdnApi from 'ai/services/sdn';
import { getGENAISession, setGENAISession, removeGENAISession } from 'ai/utils/sessionStorage';

const { wrapHOC, wrapHOCComponent } = FrameworkUtils;
const { getTextFromResource, getLocaleResourceFile } = LanguageLocaleUtils;
const getText = getLocaleResourceFile('ai/components/SuperChat/locales', 'SuperChat');

const { previousConversations } = sdnApi;

const localization = createStructuredSelector({
    title: getTextFromResource(getText, 'title')
});

const functions = (dispatch, _ownProps) => ({
    openSuperChat: entryPoint => {
        dispatch(SuperChatActions.showSuperChat(true, [], entryPoint));
    }
});

const fields = createSelector(superChatSelector, localization, coreUserDataSelector, (superChat, locales, user) => {
    return {
        localization: locales,
        user,
        ...superChat
    };
});

const withMinimizedSuperChatProps = compose(
    wrapHOC(connect(fields, functions)),
    wrapHOC(WrappedComponent => {
        class MinimizedSuperChatProps extends React.Component {
            state = {
                session: null
            };

            constructor(props) {
                super(props);
            }

            componentDidUpdate(prevProps) {
                const userDataHasChange = this.props.user?.biId !== prevProps.user?.biId;
                const userBiId = this.props.user?.biId;
                const session = getGENAISession();

                if (userDataHasChange && userBiId && session?.clientId !== userBiId) {
                    previousConversations(userBiId)
                        .then(data => {
                            const sessionData = data?.sessions?.at(-1);

                            if (sessionData) {
                                this.setState({ session: sessionData });
                                setGENAISession({
                                    sessionId: sessionData.session_id,
                                    clientId: userBiId,
                                    ...sessionData
                                });
                            } else {
                                removeGENAISession();
                                this.setState({ session: null });
                            }
                        })
                        .catch(_ => {
                            this.setState({ session: null });
                        });
                } else if (userDataHasChange && userBiId && session?.clientId === userBiId) {
                    this.setState({ session: session });
                }
            }

            componentDidMount() {
                const session = getGENAISession();

                if (session && this.props.user?.biId) {
                    this.setState({ session: session });
                }
            }

            render() {
                const { session } = this.state;

                return (
                    <WrappedComponent
                        {...this.props}
                        session={session}
                    />
                );
            }
        }

        return wrapHOCComponent(MinimizedSuperChatProps, 'MinimizedSuperChatProps', [WrappedComponent]);
    })
);

export {
    withMinimizedSuperChatProps, fields, functions
};
